<template>
    <v-container class="pa-5 d-flex flex-column" fluid style="height: 100%">
        <page-title>
            Raport wykonanych płyt
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="12" md="5" lg="3">
                <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            v-model="filters.createdAt__gte"
                            label="Od"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                            @click:clear="clearFilter('createdAt__gte')"
                        >
                            <template slot="append-outer">
                                <div class="d-flex flex-wrap">
                                    <v-btn
                                        icon
                                        x-small
                                        class="mt-n2"
                                        data-sentry-label="Zmiana daty początku zakresu raportu"
                                        @click="getForwardDate('createdAt__gte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-up
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        x-small
                                        data-sentry-label="Zmiana daty początku zakresu raportu"
                                        @click="getBackwardDate('createdAt__gte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.createdAt__gte"
                        first-day-of-week="1"
                        @input="menuFrom = false"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="5" lg="3">
                <v-menu
                    v-model="menuTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            v-model="filters.createdAt__lte"
                            label="Do"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                            @click:clear="clearFilter('createdAt__lte')"
                        >
                            <template slot="append-outer">
                                <div class="d-flex flex-wrap">
                                    <v-btn
                                        data-sentry-label="Zmiana daty końca zakresu raportu"
                                        icon
                                        x-small
                                        class="mt-n2"
                                        @click="getForwardDate('createdAt__lte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-up
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        data-sentry-label="Zmiana daty końca zakresu raportu"
                                        icon
                                        x-small
                                        @click="getBackwardDate('createdAt__lte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.createdAt__lte"
                        first-day-of-week="1"
                        @input="menuTo = false"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="5" lg="3">
                <v-btn
                    data-sentry-label="Wyszukiwanie wykonanych płyt"
                    color="success"
                    @click="getTotalPlatesReport"
                >
                    Szukaj
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end">
            <v-col cols="auto" class="d-flex justify-end align-center">
                <v-tooltip :disabled="canGenerateReport" :open-delay="tooltipDelay" top>
                    <template #activator="{on}">
                        <div v-on="on">
                            <v-btn
                                text
                                small
                                data-sentry-label="Generuj raport excel"
                                :loading="actionLoading.generateReport"
                                :disabled="!canGenerateReport"
                                @click="generateReportExcel"
                            >
                                <v-icon
                                    small
                                    left
                                    color="green"
                                >
                                    mdi-file-excel
                                </v-icon>
                                Generuj raport szczegółowy
                            </v-btn>
                        </div>
                    </template>
                    <span>Odśwież dane na wykresie</span>
                </v-tooltip>
                <v-tooltip :disabled="canGenerateReport" :open-delay="tooltipDelay" top>
                    <template #activator="{on}">
                        <div v-on="on">
                            <v-btn
                                text
                                small
                                data-sentry-label="Generuj raport"
                                :loading="actionLoading.generateReport"
                                :disabled="!canGenerateReport"
                                @click="generateReport"
                            >
                                <v-icon
                                    small
                                    left
                                    color="red"
                                >
                                    mdi-file-pdf
                                </v-icon>
                                Generuj raport
                            </v-btn>
                        </div>
                    </template>
                    <span>Odśwież dane na wykresie</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-card
            width="100%"
            height="100%"
            class="d-flex flex-column"
            :loading="actionLoading.totalPlatesReport"
        >
            <v-card-text style="height: 99%; width: 100%; position: relative">
                <canvas ref="chartContainer" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'

import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

import { errorHandler } from '@/utils/errorHandler'
import './../../../../public/fonts/roboto/Roboto-Light.js'

import { Chart, BarController, CategoryScale, LinearScale, BarElement } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { format } from 'date-fns'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    name: 'ReportPlates',
    components: {
        PageTitle,
    },
    mixins: [ filters, dateFormatter, tooltipDelay ],
    data() {
        return {
            chart: null,
            chartData: [],
            menuFrom: false,
            menuTo: false,
            actionLoading: {
                totalPlatesReport: false,
                generateReport: false
            },
            appliedFilters: {
                createdAt__gte: null,
                createdAt__lte: null,
            },
        }
    },
    computed: {
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (['createdAt__gte', 'createdAt__lte'].indexOf(item) === -1) {
                        query = this.concatItemToQuery(query, item, filters[item])
                    }
                    query = this.concatItemToQuery(query, item, filters[item])
                }
            }

            return query
        },
        reportTitle() {
            const dates = `${format(
                new Date(this.filters.createdAt__gte),
                'DD.MM.YYYY'
            )} - ${format(
                new Date(this.filters.createdAt__lte),
                'DD.MM.YYYY'
            )}`
            
            return `Raport płyt wykonanych w dniach ${dates}`
        },
        canGenerateReport() {
            return !!this.chartData.length && (
                this.appliedFilters.createdAt__gte === this.filters.createdAt__gte &&
                this.appliedFilters.createdAt__lte === this.filters.createdAt__lte
            )
        },
        userEmail() {
            return this.$store.state.user.userEmail
        },
    },
    mounted() {
        this.setDiagram()
    },
    destroyed() {
        this.chart.destroy()
    },
    methods: {
        concatItemToQuery(query, key, value) {
            if (query.length > 0) {
                return query.concat('&', `${key}=${value}`)
            }

            return query.concat(`${key}=${value}`)
        },
        async getTotalPlatesReport() {
            this.actionLoading.totalPlatesReport = true
            this.appliedFilters = Object.assign({}, this.filters)

            return await this.$store.dispatch(
                'reportsAndAnalysis/prepress/getTotalPrepressReports',
                this.filterQuery
            )
                .then(response => {
                    this.setChartData(response.data.results)
                })
                .finally(() => {
                    this.actionLoading.totalPlatesReport = false
                })
        },
        setDiagram() {
            Chart.register(BarController, BarElement, CategoryScale, LinearScale, ChartDataLabels)

            const chartContainer = this.$refs.chartContainer

            this.chart = new Chart(chartContainer, {
                type: 'bar',
                plugins: [ChartDataLabels],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            suggestedMax: 100,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 10
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            display(context) {
                                return context.dataset.data[context.dataIndex] > 0
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 4,
                            font: {
                                weight: 'bold',
                                size: 14
                            },
                        },
                        legend: {
                            display: false
                        }
                    }
                },
            })
        },
        setChartData(reportsData) {
            this.chartData = reportsData
            this.chart.data.labels = reportsData.map(item => item.shiftType)
            this.chart.data.datasets = [{
                data: reportsData.map(item => item.numberOfPlatesSum),
                backgroundColor: '#2196F3',
                borderWidth: 0,
                borderRadius: 5,
            }]

            this.chart.update()
        },
        getBackwardDate(date) {
            if (Date.parse(this.filters[date])) {
                this.filters[date] = this.getDayBackward(this.filters[date])
            }
        },
        getForwardDate(date) {
            if (Date.parse(this.filters[date])) {
                this.filters[date] = this.getDayForward(this.filters[date])
            }
        },
        generateReport() {
            this.actionLoading.generateReport = true

            html2canvas(this.$refs.chartContainer)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/png'),
                        doc = new jsPDF({
                            orientation: 'landscape'
                        })

                    doc.setFont('Roboto-Light')
                    doc.text(`${this.reportTitle}`, 10, 10)
                    doc.addImage(imgData, 'PNG', 10, 40, 275, 130)
                    doc.setFontSize(10)

                    doc.text(`Wygenerowano: ${this.formatDate(new Date())}`, 10, 200)

                    window.open(doc.output('bloburl'), '_blank')
                    this.actionLoading.generateReport = false

                })
                .catch(() => {
                    this.actionLoading.generateReport = false
                })
        },
        generateReportExcel() {
            this.$store.dispatch(
                'reportsAndAnalysis/prepress/generateExcelReport',
                { query: this.filterQuery, userEmail: this.userEmail }
            )
                .finally(() => {
                    this.actionLoading.additionalPlatesReport = false
                })
        },
        close() {
            this.$router.push({ name: 'ReportingAndAnalysisPrepressPrepress' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>